export const environment = {
	production: false,
	lang: 'es',
	//apiUrl: 'http://172.206.128.104:8100/v2/', //URL SERVIDOR SPOT
	// apiUrl: 'http://10.99.9.242:8081/', //ULR SERVIDOR CLIENTE QA
    // apiUrl: 'http://10.77.109.34:8081/', //ULR SERVIDOR CLIENTE PROD
	apiUrl: 'v2/', //URL SERVIDOR SPOT
	apiUrlQeQ: 'localhost',
	rolAtiendeCasosId: '1',
	entidad: 2,
	pagos: false,
	credito: true,
	cuenta: true,
	factoraje: false,
	aseguradora: false,
	ahorro: false,
	pagares: false,
	traduccion: false,
	version: '2.5.0',
	aesKey: 'cKUlJ8M62ou2pxpM2XVB6E/Dn8yhUd9liQDfjfFJAy0=',
	aesIV: '0lfr5mznSlq/OkBqxZlWjA==',
	ambiente: 1 // 1- QA, 2- PROD
};
